import React, { useState } from "react";

import {
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  IconButton,
  Stack,
  Tooltip,
  Chip,
  Link,
} from "@mui/material";
import * as Constants from "../../support/Constants";
import moment from "moment";
import Linkify from "linkify-react";
import { CloudDownload, Verified } from "@mui/icons-material";
import { copyHash, shortHash } from "../utiles/hashUtils";

const Comentario = ({ comentario }) => {
    const [copiedIndex, setCopiedIndex] = useState(null);

  return (
    <ListItem alignItems="flex-start">
      <ListItemAvatar>
        <Avatar
          sx={{
            backgroundColor:
              Constants.MEMBER_TYPE_COLORS[comentario.memberType],
          }}
        >
          {Constants.obtenerSiglas(comentario.memberName)}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <>
            <Typography variant="subtitle1">{comentario.memberName}</Typography>
            <Typography variant="caption">
              {moment(comentario.commentDate).format("DD-MM-YYYY")}
            </Typography>
          </>
        }
        secondary={
          <>
            {" "}
            <Typography variant="body1" sx={{ mt: 0.5 }}>
              <Linkify>{comentario.comment}</Linkify>
            </Typography>
            {comentario.files && comentario.files.length > 0 && (
              <Stack mt={1.5} gap={1}>
                {comentario.files.map((doc, index) => (
                  <Stack
                    key={doc.fileId ?? doc.id ?? doc.url ?? index}
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{
                      border: "1px solid #e0e0e0",
                      borderRadius: "6px",
                      p: 1,
                    }}
                  >
                    <Stack direction="row" alignItems="center" gap={1}>
                      <Typography fontWeight={500}>
                        {doc.name || doc.fileName || "Documento"}
                      </Typography>

                      {doc.hash && (
                        <Tooltip
                          title={
                            copiedIndex === index
                              ? "¡Copiado!"
                              : `SHA-256: ${doc.hash}`
                          }
                        >
                          <Chip
                            size="small"
                            label={
                              copiedIndex === index
                                ? "¡Copiado!"
                                : `SHA-256: ${shortHash(doc.hash)}`
                            }
                            variant="outlined"
                            onClick={() =>
                              copyHash(doc.hash, setCopiedIndex, index)
                            }
                            sx={{ cursor: "pointer" }}
                          />
                        </Tooltip>
                      )}

                      {doc.txHash && (
                        <Tooltip
                          title={`Verificado en blockchain: ${doc.txHash}`}
                        >
                          <Verified fontSize="small" color="success" />
                        </Tooltip>
                      )}
                    </Stack>

                    <Stack direction="row" gap={1}>
                      {doc.url && (
                        <Tooltip title="Descargar">
                          <IconButton
                            component={Link}
                            href={doc.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            size="small"
                          >
                            <CloudDownload fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                    </Stack>
                  </Stack>
                ))}
              </Stack>
            )}
          </>
        }
      />
    </ListItem>
  );
};

export default Comentario;
